import { runInAction, makeAutoObservable } from 'mobx';
import { Services } from '../API';
import { Extent as olExtent } from 'ol/extent';
import image from '@assets/images/gerb.svg';

export class SettingsStore {
  private _services: Services;

  data: {
    title?: string;
    logo_url?: string;
    default_map_extent?: olExtent;
    default_map_srid?: number;
    default_map_name?: string;
  } = {
    title: 'Геоинформационная система Ростовской области',
    logo_url: image,
    default_map_extent: [39.53, 47.33, 39.91, 47.06],
    default_map_srid: 3857,
    default_map_name: '',
  };
  isLoading = true;

  constructor(services: Services) {
    this._services = services;
    makeAutoObservable<SettingsStore, '_services'>(this, { _services: false });
  }

  load = async () => {
    runInAction(() => (this.isLoading = true));
    try {
      const settings = await this._services.settings.get();
      runInAction(() => (this.data = Object.assign({}, this.data, settings)));
      /*
      В идеале бэкенд в параметре 'logo_url' должен отдавать абсолютную ссылку,
      а не относительную
      */
      if (this.data.logo_url) {
        this.data.logo_url = process.env.BACKEND_URL + this.data.logo_url;
      }
    } catch (e) {
      // TO DO
      console.log(e);
    } finally {
      runInAction(() => (this.isLoading = false));
    }
  };
}
